import React, { useState, useEffect, useContext } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";

import logo from "assets/img/EBay_logo.svg";
import { Card, CardBody, Layout, Menu } from "antd";

import { Row, Col, Button, Space, message, Empty, Spin } from "antd";

import { setBreadcrumb } from "redux/actions/app.action";
import generalService from "../services/general.service";
import NoteService from "../services/note.service";

import Header from "components/shared/Header";
import Filter from "components/overview/Filter";
import DataTable from "components/overview/DataTable";
import emptyImg from "../assets/img/empty.svg";

import { useHistory } from "react-router-dom";
import router from "router";
import moment from "moment";
import { SocketContext } from "contexts/SocketContext";
import { AppContext } from "contexts/AppContext";

import {
  ACTION,
  CANCEL_REQUEST,
  DATE_TIME_FORMAT,
  FILE_TYPE,
  WS_URL,
  TOKEN_NAME,
} from "constants/index";

const { Sider } = Layout;
const { SubMenu } = Menu;

const Sidebar = ({ collapsed, onCollapse }) => {
  const socket = useContext(SocketContext);
  const appContext = useContext(AppContext);
  const [tableData, setTableData] = useState([]);
  const [wsMessage, setWSMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const history = useHistory();

  const goto = (path) => {
    redirect(path);
  };
  const redirect = (path) => {
    history.push({
      pathname: path.pathname,
    });
  };

  useEffect(() => {
    socket.on("update-note-list", (notes) => {
      if (notes) {
        setTableData(notes);
      } else {
        setTableData([]);
      }
    });
    dispatch(setBreadcrumb(["All listing"]));
    onSearch({ status: 0 });
  }, [socket]);

  const onSearch = (params) => {
    setIsLoading(true);
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    NoteService.getListItems(params, source).then(
      (request) => {
        setTableData(request.notes);
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      },
      (error) => {
        if (error && error.message !== CANCEL_REQUEST) {
          message.error("API got error, please contact us.", 5);
        }
        console.log(error);
        setIsLoading(false);
        return Promise.reject();
      }
    );
  };

  const Note = (data) => {
    return (
      <>
        <Space
          key={data.id}
          direction="vertical"
          size={16}
          style={{ width: "100%" }}
        >
          <Card
            bordered={true}
            className={
              data.id == appContext.selectedNote
                ? "activity-item active"
                : "activity-item"
            }
            onClick={() => {
              goto({ pathname: `/main/note/${data.id}` });
            }}
          >
            <h4>{data.title}</h4>
            <span>
              {moment(data.updated_date).isSame(moment(), "day")
                ? moment(data.updated_date).format(DATE_TIME_FORMAT.TIME)
                : moment(data.updated_date).format(DATE_TIME_FORMAT.DATE)}
            </span>
            <div>{data.sub_title}</div>
          </Card>
        </Space>
      </>
    );
  };

  return (
    <>
      <Sider
        theme="light"
        id="sider"
        width={200}
        // breakpoint="lg"
        // collapsible
        // collapsed={collapsed}
        // onCollapse={onCollapse}
      >
        {tableData ? (
          <>
            {!isLoading ? (
              tableData.map((s) => Note(s))
            ) : (
              <Empty
                image={emptyImg}
                imageStyle={{
                  height: 60,
                }}
                description={<span>Loading..</span>}
              >
                <Spin />
              </Empty>
            )}
          </>
        ) : (
          <Empty
            image={emptyImg}
            imageStyle={{
              height: 60,
            }}
            description={<span>No Notes</span>}
          ></Empty>
        )}
      </Sider>
    </>
  );
};
export default Sidebar;
